<div class="modal-header">
  <h4 class="modal-title h1 pull-left">Receipt details</h4>
  <btn-close class="pull-right" (click)="modalRef.hide()"></btn-close>
</div>
<div class="modal-body" style="min-height: 100px">
  <table class="table table-bordered mb-0">
    <thead>
    <tr>
      <th>ID</th>
      <th>Created at</th>
      <th>Updated at</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of items">
      <td>
        <a class="border-dotted cursor-pointer" (click)="showReceipt(item.id)">
          {{ item.id }}
        </a>
      </td>
      <td>{{ item.createdAt | moment }}</td>
      <td>{{ item.updatedAt | moment }}</td>
    </tr>
    </tbody>
  </table>
<!--  <preloader [hidden]="!loaderService.isLoading"></preloader>-->
</div>
<div class="modal-footer border-0">
  <button class="btn btn-success px-4" (click)="modalRef.hide()">
    OK
  </button>
</div>
